import { useTranslations } from 'next-intl';
import { CatHeading } from 'components/blocks-components';

export const SerialEquipmentSearchDescription = () => {
  const t = useTranslations();
  return (
    <div className="mb-3">
      <CatHeading variant="label-lg">
        {t('BY_SERIAL_EQUIP_SEARCH_DESC')}
      </CatHeading>
    </div>
  );
};
